import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import API from "../../actions";


export default props => {
    const [text, setText] = useState("");
    const [comment, setComment] = useState([]);
    const [saveTimeout, setSaveTimeout] = useState(null);
    const [disabled, setDisabled] = useState(false);
    // const [error, setError] = useState('');

    useEffect(() => {
        // console.log('props', props);
        setText(props.comment.value);
        setComment(props.comment);
        if (props.comment.createdAt) {
            const subTime = new Date().getTime() - new Date(props.comment.createdAt).getTime();

            // set disable after created 24h
            setDisabled(subTime > 86400000);
        }
    }, [props.comment]);

    const saveComment = (comment, text) => {
        // console.log(comment, text);
        setText(text);
        clearTimeout(saveTimeout);
        setSaveTimeout(setTimeout(async () => {
            const newComment = { ...comment };
            newComment.value = text;
            const savedComment = await API.setFieldComment(newComment);
            if (savedComment) {
                setComment(savedComment);
                if (typeof props.onSavedComment === 'function') {
                    props.onSavedComment(savedComment);
                }
            }
        }, 2000));
    }

    return (
        <>
            <TextField
                label={props.label}
                id={'idsm-' + (props.comment.id || props.comment.refId)}
                key={'keysm-' + (props.comment.id || props.comment.refId)}
                multiline
                InputLabelProps={{ shrink: true }}
                type="text"
                disabled={disabled}
                value={text}
                onChange={event => saveComment(comment, event.target.value)}
                style={{ margin: "10px auto 10px auto", width: "100%" }}
            />
        </>
    );
};